import { url_add_param, url_remove_param } from "../../../util/methods"

$(document).on("turbolinks:load", function () {
  // The product filter is a select2 search select, so its options are built
  // dynamically and can't carry the data-type attributes js-sort-selectFilter
  // relies on — navigate with the sort_product param directly instead.
  $(".js-events-product-filter").on("change", function () {
    var value = $(this).val()
    var url = url_remove_param(location.href, "sort_product")
    url = url_remove_param(url, "page")
    if (value) {
      url = url_add_param(url, "sort_product", value)
    }
    Turbolinks.visit(url)
  })
})
